<template>
  <section class="challenge-content">
    <div class="left">
      <div class="first">{{challenges_}}</div>
      <div class="second">
        <router-link v-for="challenge in challenges" :to="'/challenge/' + challenge.pid" :class="['question', {solved: challenge.already_solved}]" :key="challenge.pid">
          <span>{{challenge.score}}</span>
          <div class="question-name">
            <span>{{challenge.title}}</span>
          </div>
          <div class="block" :class="{solved: challenge.already_solved}"></div>
        </router-link>
      </div>
    </div>
    <div class="right">
      <div class="first" v-if="isRank">
        <h5>{{topTeams_}}</h5>
        <table class="table">
          <thead>
            <tr>
              <th>{{rank_}}</th>
              <th>{{team_}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, index) in rankInfo">
              <td>{{index + 1}}</td>
              <td>{{r}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { list } from '@/utils/api.js'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        challenges: [],
        isRank: true,
        rankInfo: []
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale', 'theme']),
      ...mapGetters(['gameOver']),
      ...i18n.map(['challenges_', 'topTeams_', 'rank_', 'team_'])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([])
    },
    created () {
      if (!this.profile.name) return this.$router.push('login')

      list()
        .then((data) => {
          this.challenges = data.problems
        })
        .catch((err) => {
          this.$emit('msg', {
            msg: err.message,
            type: 'error',
            delay: 2000
          })
        })
    }
  }
</script>

<style lang="less" scoped>
  .question {
    & .block {
      display: none;
    }
    &:hover .block {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/challenge.vue